/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

/**
 * 获取菜鸟App业务版本。"ORIGINAL", "CAMPUS", "HOMETOWN"  分别对应 大众版、校园版 、家乡版
 * SDK: https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
 * @example
 * import { getAppBaseInfo } from '@alife/cn-uni-api';
 *
 * getAppBaseInfo()
 * .then(res => res.cnVersionName === 'CAMPUS')
 * .catch((err) => console.error(err))
 *
 * @author 敬文
 */
var getAppBaseInfo = extend({
    web: {
        windvane: {
            cn: function (options, context) {
                var _a;
                // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
                // TODO getAppBaseInfo做成1个通用的能力,目前菜鸟Hybrid只找到这1个 JSBridge，以后再扩展更多字段。
                (_a = context === null || context === void 0 ? void 0 : context.WVCall) === null || _a === void 0 ? void 0 : _a.call(context, 'CNHybridGGHomeVersionManage.currentVersion', options, {
                    formatOutput: function (ret) {
                        var _a;
                        return ({
                            cnVersionName: (_a = ret === null || ret === void 0 ? void 0 : ret.data) === null || _a === void 0 ? void 0 : _a.version,
                        });
                    },
                });
            },
        },
    },
});

export { getAppBaseInfo };
